import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProductList from './product_list';
import ProductDetail from './product_detail';

class Product extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <ProductList/>;
    }else{
      if(params.id===undefined){
        view = <ProductDetail/>;
      }else{
        view = <ProductDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Product.contextTypes = {
  router: PropTypes.object
};

export default Product;
